import { render } from "./QualityInspectionList.vue?vue&type=template&id=6d4f8dd8"
import script from "./QualityInspectionList.vue?vue&type=script&lang=js"
export * from "./QualityInspectionList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__